export const placeholderColor = '#EB0000'
